import React from 'react';
import './App.css';
import Portfolio from './components/Portfolio';
export default function App() {
  return <Portfolio />;
}
